// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageGuard_root__I2zH8","red":"ImageGuard_red__fOCqH"};